import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce6511b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-employee-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Employee Salaries", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "user" }, "User", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "hourly_pay" }, "Hourly Pay", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "workCenter" }, "Work Center", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "active" }, "Active", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Save", -1))

import { ref, onMounted, watch } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { postToUrl } from '@/api/api';
import { User } from '@/types/Ops';

interface UserEmployee {
    user: number;
    hourly_pay: number;
    work_centers: number[];
    active: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUserEmployee',
  setup(__props) {

const userStore = useUserStore();
const employeeStore = useEmployeeStore();
const users = ref<User[]>([]);
const work_centers = ref<WorkCenter[]>([]);
const selectedUserId = ref<number | null>(null);
const selectedWorkCenterId = ref<number | null>(null);
const employee = ref<UserEmployee>({
    user: 0,
    hourly_pay: 0,
    work_centers: [],
    active: false
});

const errorMsg = ref('');

const clearUserErrorMsg = () => {
    errorMsg.value = '';

};

const fetchWorkCenters = async () => {
    try {
        const response = await fetch('/ops/api/workcenters/');
        if (response.ok) {
            work_centers.value = await response.json();
        } else {
            console.error('Failed to fetch work centers');
        }
    } catch (error) {
        console.error('Network error:', error);
    }
};

onMounted(async () => {
    await userStore.fetchAllUsers();
    users.value = userStore.Users;
    await fetchWorkCenters();
    await employeeStore.fetch();
    users.value = userStore.Users.filter(user => {
        const userEmployee = employeeStore.getById(user.id);
        return !userEmployee || userEmployee.hourly_pay === null;
    });
});

const updateDisplayedUser = () => {
    const selectedUser = users.value.find(u => u.id === selectedUserId.value);
    if (selectedUser) {
        employee.value.user = selectedUser.id; // Update the user_id property
    }
};

const updateWorkCenter = () => {
    if (selectedWorkCenterId.value) {
        employee.value.work_centers = [selectedWorkCenterId.value];
    }
};

watch(selectedUserId, (newVal, oldVal) => {
    if (newVal !== oldVal) {
        updateDisplayedUser();
    }
});

watch(selectedWorkCenterId, (newVal) => {
    if (newVal !== null) {
        updateWorkCenter();
    }
});

const resetForm = () => {
    selectedUserId.value = null;
    selectedWorkCenterId.value = null;
    employee.value = { user: 0, hourly_pay: 0, work_centers: [], active: false };
};

const createEmployee = async () => {
    const selectedUserIdValue = selectedUserId.value;
    if (selectedUserIdValue !== null && !isNaN(selectedUserIdValue) && selectedWorkCenterId.value !== null) {
        const userId = Number(selectedUserIdValue); // Convert to number
        const workCenterId = Number(selectedWorkCenterId.value); // Convert to number
        if (employee.value.user !== userId) {
            console.error('Mismatched user ID:', employee.value.user, '!==', userId);
            return;
        }
        const postData = {
            user: userId,
            hourly_pay: employee.value.hourly_pay,
            active: employee.value.active,
            work_centers: [workCenterId],
        };
        try {
            const response = await postToUrl('/ops/api/create_user_employee/', postData);
            alert('User employee created successfully!');
            resetForm();
        } catch (error) {
            console.error('Error creating employee:', error);
            alert('Error creating employee: ' + error.message);
        }
    } else {
        console.error('User or Work Center not selected');
        alert('Please select both a user and a work center');
    }

};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _withModifiers(createEmployee, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          id: "user",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUserId).value = $event)),
          onChange: updateDisplayedUser,
          onInput: clearUserErrorMsg
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
            return (_openBlock(), _createElementBlock("option", {
              key: user.id,
              value: user.id
            }, _toDisplayString(user.full_name), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedUserId.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          id: "hourly_pay",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((employee.value.hourly_pay) = $event)),
          type: "number",
          required: ""
        }, null, 512), [
          [_vModelText, employee.value.hourly_pay]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("select", {
          id: "workCenter",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedWorkCenterId).value = $event)),
          onChange: updateWorkCenter
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work_centers.value, (workCenter) => {
            return (_openBlock(), _createElementBlock("option", {
              key: workCenter.id,
              value: workCenter.id
            }, _toDisplayString(workCenter.name), 9, _hoisted_10))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedWorkCenterId.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          id: "active",
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((employee.value.active) = $event))
        }, null, 512), [
          [_vModelCheckbox, employee.value.active]
        ])
      ]),
      _hoisted_13
    ], 32)
  ]))
}
}

})